import React from "react";
import { Box } from "@mui/system";
import { COLORS } from "components";
import { getFormattedDate } from "utils";

interface DateRangeDisplayProps {
    startDate: string;
    endDate: string;
}

export const DateRangeDisplay = ({ startDate, endDate }: DateRangeDisplayProps) => <Box
    sx={{
        display: 'flex',
        alignItems: 'center',
        width: "fit-content",
        height: "36px",
        px: "16px",
        border: `1px solid ${COLORS.Mainblue}`,
        borderRadius: "20px",
        fontSize: "12px",
        color: COLORS.Mainblue,
        fontWeight: 500,
        marginRight: '30px',
    }}
>
    {`${getFormattedDate(startDate, "/")} - ${getFormattedDate(endDate, "/")}`}
</Box>